import { render } from "./BMICalculator.vue?vue&type=template&id=5faf1561&scoped=true"
import script from "./BMICalculator.vue?vue&type=script&lang=js"
export * from "./BMICalculator.vue?vue&type=script&lang=js"

import "./BMICalculator.vue?vue&type=style&index=0&id=5faf1561&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faf1561"]])

export default __exports__